import { defineMessage } from '../../services/localization';

export const messages = {
    hours: defineMessage('hours_plural_one_hour_other_hours'),
    minutes: defineMessage('minutes_plural_one_minute_other_minutes'),
};
